/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ImportFromCommunityLibraryItemAssignmentDataParser = 
/* #__PURE__ */ parsers.object([['dataUrl', codecString, 'data_url']]);
export class ImportFromCommunityLibraryItemAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ImportFromCommunityLibraryItemAssignmentDataParser.decode(input).map(res => new ImportFromCommunityLibraryItemAssignmentData(res));
    }
    static unsafeDecode(input) {
        return ImportFromCommunityLibraryItemAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ImportFromCommunityLibraryItemAssignmentDataParser.encode(data);
    }
    static schema() {
        return ImportFromCommunityLibraryItemAssignmentDataParser.schema();
    }
}
